import React from "react"
import { nanoid } from "nanoid"

import firebase, { fbAuth } from "../services/Firebase"
import google from "../assets/google.png"
import logo from "../assets/logo.svg"
import { Swiper, SwiperSlide } from "swiper/react"
import SwiperCore, { Pagination } from "swiper"
import "swiper/swiper-bundle.min.css"

SwiperCore.use([ Pagination ])

function Onboarding() {
    const handleSignIn = () => {
        const provider = new firebase.auth.GoogleAuthProvider()
        fbAuth.signInWithPopup(provider).catch((error) => window.alert(error))
    }

    const handleSignInAnonymously = () => fbAuth.signInAnonymously()

    const info = [
        {
            title: "Welcome to Recipesy!",
            message: "The app that could solve your puzzling question: \"What's for today's meal?"
        },
        {
            title: "Fast & Easy",
            message: "Brings the recipes to you with a frictionless lightning speed"
        },
        {
            title: "Voice Recognition",
            message: "Integrated with voice recognition for seamless searching process"
        },
        {
            title: "Nutrition Information",
            message: "In-depth nutrition information to serve the most strict users"
        },
        {
            title: "Wine Lovers",
            message: "Good meals usually come with good wine 😉!"
        }
    ]

    return (
        <div id="onboardingContainer">
            <section id="onboarding">
                <img id="logo" src={logo} alt="App Logo" />

                <Swiper
                    pagination={{ clickable: true }}
                    spaceBetween={20}
                    slidesPerView={1}
                    loop="true"
                >
                    {
                        info.map( item => {
                            return  <SwiperSlide key={nanoid()} className="onboardingSlide" >    
                                <div>
                                    <h3>{item.title}</h3>
                                    <p>{item.message}</p>
                                </div>
                            </SwiperSlide>
                        })
                    }
                </Swiper>

                <img src={google} alt="Sign In With Google" id="signinWithGoogle" onClick={handleSignIn}/>
                <button onClick={handleSignInAnonymously}>Continue As Guest</button>
            </section>
        </div>
    )
}

export default Onboarding
